<template>
  <main class="layout">
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增</el-button>
        <el-button @click="$_batchImport" class="btn__add">批量导入</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="系统类型:">
          <el-select v-model="filter.serviceType" style="width: 110px;" filterable>
            <el-option
              v-for="item in typeEnums"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="系统名称:">
          <el-select v-model="filter.serviceName" style="width: 110px;" filterable>
            <el-option
              v-for="item in nameEnums"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="配置维度:">
          <el-select v-model="filter.scope" style="width: 110px;" filterable>
            <el-option
              v-for="item in scopeEnums"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
              class="input-box"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该运营商，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
              class="input-box"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该品牌，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="配置名称:">
          <el-select v-model="filter.configType" style="width: 110px;" filterable>
            <el-option
              v-for="item in configEnums"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关键key:">
          <el-input v-model="filter.key" class="input-box"></el-input>
        </el-form-item>

        <el-form-item label="映射值:">
          <el-input v-model="filter.value" class="input-box"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
          <el-button @click="$_export" class="export__btn">导出</el-button>
        </el-form-item>
      </el-form>
    </section>
    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="220" :resizable="false">
          <template slot-scope="scope">
            <el-button
              class="edit__btn"
              @click="$_modify(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button class="delete__btn" @click="$_delete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
        ></el-table-column>
        <div class="table-list__empty" slot="empty">列表暂无数据</div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getDataList"
      ></cd-pagination>
    </div>
    <!-- 新增、编辑 -->
    <modal-modify
      v-if="modal.show && modal.template === 'modal-modify'"
      :title="modal.title"
      :parentData="modal.data"
      :typeEnums="typeEnums"
      :nameEnums="nameEnums"
      :scopeEnums="scopeEnums"
      :configEnums="configEnums"
      @close="$_close"
      @success="$_successCallback"
    ></modal-modify>

      <!-- S 导出数据弹窗 -->
      <export-data
        v-if="modal.show && modal.template === 'export-data'"
        :title="modal.title"
        emailType="string"
        :filterData="modal.data"
        actionName="enumBatchEXport"
        @close="$_close"
      ></export-data>
      <!-- E导出数据弹窗 -->
      <!-- S 批量导入数据弹窗 -->
      <batch-mapping
        v-if="modal.show && modal.template === 'batch-mapping'"
        :title="modal.title"
        :typeEnums="typeEnums"
        :nameEnums="nameEnums"
        :configEnums="configEnums"
        @success="$_search"
        @close="$_close"
      ></batch-mapping>
      <!-- E 批量导入数据弹窗 -->
  </main>
</template>

<script>
import autocompletePlatform from "@/mixins/autocompletePlatform";
import autocompleteBrands from "@/mixins/autocompleteBrands";
import ExportData from "@/components/modal/modal-export-data";
import BatchMapping from "./modal-batch-mapping";
import resize from "@/mixins/resize";
import handlePagination from "@/mixins/handlePagination";
import ModalModify from "./modal-modify";

export default {
  name: "mapping-enum",
  mixins: [
    autocompletePlatform,
    autocompleteBrands,
    resize, 
    handlePagination
  ],
  data() {
    const columns = [
      { key: "serviceTypeDesc", label: "系统类型", width: 160 },
      { key: "serviceNameDesc", label: "系统名称", width: 160 },
      { key: "scopeDesc", label: "配置维度", width: 160 },
      { key: "platformName", label: "运营商", width: 160 },
      { key: "brandName", label: "品牌", width: 160 },
      { key: "configTypeDesc", label: "配置名称", width: 160 },
      { key: "key", label: "关键key", width: 160 },
      { key: "value", label: "映射值", width: 160 },
      { key: "creator", label: "创建人", width: 120 },
      { key: "createTime", label: "创建时间", width: 180 },
      { key: "operator", label: "最后编辑人", width: 120 },
      { key: "updateTime", label: "最后编辑时间", width: 180 },
    ];
    return {
      isLoading: false,
      filter: {
        serviceType: "",
        serviceName: "",
        scope: "",
        configType: "",
        key: "",
        value: ""
      },
      typeEnums: [],
      nameEnums: [],
      scopeEnums: [],
      configEnums: [],
      dataList: [],
      columns,
      modal: {
        show: false,
        title: "",
        data: {},
        template: "",
      },
    };
  },
  methods: {
    getEnumList(){
      this.$service.post("getServiceTypeEnum").then((result) => {
        if (result.$.checkResult(result, true)) {
          this.typeEnums = JSON.parse(result.data);
        }
      });
      this.$service.post("getServiceNameEnum").then((result) => {
        if (result.$.checkResult(result, true)) {
          this.nameEnums = JSON.parse(result.data);
        }
      });
      this.$service.post("getConfigScopeEnum").then((result) => {
        if (result.$.checkResult(result, true)) {
          this.scopeEnums = JSON.parse(result.data);
        }
      });
      this.$service.post("getConfigTypeEnum").then((result) => {
        if (result.$.checkResult(result, true)) {
          this.configEnums = JSON.parse(result.data);
        }
      });
    },
    // 重置
    $_reset() {
      for (const [key, value] of Object.entries(this.filter)) {
        if (typeof value === "string") {
          this.filter[key] = "";
        } else if (typeof value === "number") {
          this.filter[key] = 0;
        }
      }
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getDataList();
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 获取数据列表
    $_getDataList() {
      let {
        serviceType= "",
        serviceName= "",
        scope= "",
        configType= "",
        key= "",
        value= "",
        platformKey = "",
        brandId = "",
      } = this.filter;
      let { pageNow = 1, pageSize = 20 } = this.pagination;
      this.$service
        .post("getCustomEnumMapping", {
          serviceType,
          serviceName,
          scope,
          configType,
          key,
          value,
          platformKey,
          brandId: brandId || null,
          pageNow,
          pageSize,
        })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            let { pages = 0, total = 0, rows = [] } = result.data;
            this.pagination.pages = pages;
            this.pagination.total = total;
            this.dataList = rows.splice(0);
          }
        });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getDataList();
    },
    // 批量导入
    $_batchImport() {
      this.modal.title = '批量导入定制枚举映射';
      this.modal.template = "batch-mapping";
      this.modal.show = true;
    },
    // 导出
    $_export() {
      this.modal.title = "提示";
      this.modal.template = "export-data";
      const {
        serviceType,
        serviceName,
        scope,
        configType,
        key,
        value,
        brandId,
        platformKey
      } = this.filter

      let postData = {
        serviceType,
        serviceName,
        scope,
        configType,
        key,
        value,
        platformKey
      }
      if(brandId){
        Object.assign(postData, {
          brandId 
        })
      }

      this.modal.data = postData;
      this.modal.show = true;
    },
    // 新增/编辑
    $_modify(index, row) {
      let action = "新增";
      if (index !== -1) {
        action = "编辑";
        this.modal.data = { ...row };
      }
      this.modal.template = "modal-modify";
      this.modal.title = `${action}定制枚举映射`;
      this.modal.show = true;
    },
    // 删除按钮
    $_delete(row) {
      const self = this;
      let content = `
				<div>该映射信息将不可恢复，确认删除？</div>
			`;
      let { id } = row;
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service.post("enumDelete", { id }).then((result) => {
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  // todo 是否需要获取最新的筛选条件
                  // self.filter = Object.assign(self.$refs.filterBox.filter);
                  self.$_getDataList();
                },
              });
            }
          });
        },
      });
    },
    // 弹窗成功回调
    $_successCallback() {
      this.$_close();
      this.$nextTick(() => {
        this.$_getDataList();
      });
    },
    // 关闭本页面发起的弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
  },
  mounted() {
    this.getEnumList();
    this.$_getDataList()
  },
  components: {
    ModalModify,
    ExportData,
    BatchMapping
  },
};
</script>
<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  height: 100%;
  border: 1px solid #eee;
}
.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;
  .top-btns {
    height: 50px;
  }
}
.input-box {
  width: 110px;
}
</style>
